// Formats teamMember names into "First, Second, Third & Fourth" pattern
const stringifyTeamMembers = (teamMembers) =>
  teamMembers
    ? teamMembers
        .map((member) => member.content?.fullName)
        .filter((member) => member)
        .join(', ')
        .replace(/,([^,]*)$/, ' &$1')
    : '';

export default stringifyTeamMembers;
